import { useEffect, useRef } from 'react';
import { useApp } from './AppProvider';

const useAuthentication = (connectorId?: string) => {
    const {
        language,
        connectors,
        onUpdateConnectorScope,
        onUpdateConnectorNonRedirectAuth,
        listenForAuthenticationEvent,
    } = useApp();

    const authWindow = useRef<Window | null>(null);
    const authMessageHandler = useRef((event: MessageEvent) => {
        if (event.origin === window.origin) {
            if (event.data?.id === connectorId && event.data.authenticated === true) {
                authWindow.current?.close();
                if (
                    event.data.authType === 'BASICAUTH' ||
                    event.data.authType === 'APIKEY' ||
                    event.data.authType === 'CUSTOM'
                ) {
                    onUpdateConnectorNonRedirectAuth(
                        connectorId as string,
                        event.data?.authenticated,
                    );
                } else {
                    onUpdateConnectorScope(connectorId as string, event.data?.scopes);
                }
            }
        }
    });

    useEffect(() => {
        const handler = authMessageHandler.current;

        window.addEventListener('message', handler);

        return () => {
            window.removeEventListener('message', handler);
        };
    }, []);

    const onAuthenticate = (scope: string) => {
        if (!connectorId) {
            return;
        }

        switch (connectors[connectorId].$t.toUpperCase()) {
            case 'BASIC':
                authWindow.current = window.open(
                    `${window.origin}/connector/${connectorId}/basicauth/authenticate?language=${language}&scope=${scope}`,
                    connectors[connectorId].displayName,
                    'width=500,height=700',
                );
                listenForAuthenticationEvent(connectorId);
                break;

            case 'APIKEY':
                authWindow.current = window.open(
                    `${window.origin}/connector/${connectorId}/apikey/authenticate?language=${language}&scope=${scope}`,
                    connectors[connectorId].displayName,
                    'width=500,height=700',
                );
                listenForAuthenticationEvent(connectorId);
                break;

            case 'OAUTH':
                authWindow.current = window.open(
                    `${window.origin}/connector/${connectorId}/oauth/authenticate?language=${language}&scope=${scope}`,
                    connectors[connectorId].displayName,
                    'width=500,height=700',
                );
                listenForAuthenticationEvent(connectorId);
                break;
            case 'CUSTOM':
                authWindow.current = window.open(
                    `${window.origin}/connector/${connectorId}/custom/authenticate?language=${language}&scope=${scope}`,
                    connectors[connectorId].displayName,
                    'width=500,height=700',
                );
                listenForAuthenticationEvent(connectorId);
                break;
        }
    };

    return {
        onAuthenticate,
    };
};

export default useAuthentication;
